import _ from 'lodash'

import { SearchItemField } from '../SearchResultItem'
import { DisplayField } from '../../pages/CompanyDetail/Configuration/config'
import { InfoBox } from '../InfoBox'

export const address = 'Address'

function getCompanyFieldDesktopWidth(
  fields: DisplayField[] | SearchItemField[],
  label: string,
  defaultDesktopWidth: number
) {
  switch (fields.length) {
    case 1:
      return 1
    case 2:
    case 3: {
      if (
        _.includes(
          _.map(fields, f => f.label),
          address
        )
      ) {
        return label === address ? 0.5 : defaultDesktopWidth
      }
      return defaultDesktopWidth
    }
    default:
      return defaultDesktopWidth
  }
}

type companyInfoBoxProps = {
  fields: SearchItemField[] | DisplayField[]
  defaultDesktopWidth: number
  pb?: number
  automationId?: string
}

export const CompanyInfoBoxes = ({ fields, defaultDesktopWidth, pb, automationId }: companyInfoBoxProps) => {
  return (
    <>
      {_.map(fields, f => {
        const fieldWidth = getCompanyFieldDesktopWidth(fields, f.label, defaultDesktopWidth)
        return (
          <InfoBox
            boxProps={{ width: [1, 0.5, fieldWidth], pb: pb }}
            key={f.label}
            label={f.label}
            value={f.value}
            maxItems={f.maxItems}
            data-automation-id={automationId}
          />
        )
      })}
    </>
  )
}
